import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

export default function PublicSiteShell() {
  const location = useLocation();

  useEffect(() => {
    document.documentElement.dataset.brand = 'mapleos';
    document.documentElement.classList.add('allow-window-scroll');

    return () => {
      delete document.documentElement.dataset.brand;
      document.documentElement.classList.remove('allow-window-scroll');
    };
  }, []);

  useEffect(() => {
    if (location.hash) {
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.search, location.hash]);

  return <Outlet />;
}